// store/actions/CategoryType.js

export const CONFIRMED_CREATE_CATEGORY_ACTION = "CONFIRMED_CREATE_CATEGORY_ACTION";
export const CONFIRMED_DELETE_CATEGORY_ACTION = "CONFIRMED_DELETE_CATEGORY_ACTION";
export const CONFIRMED_EDIT_CATEGORY_ACTION = "CONFIRMED_EDIT_CATEGORY_ACTION";
export const CONFIRMED_GET_CATEGORIES = "CONFIRMED_GET_CATEGORIES";
